<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M6.5 6.5H18.5V21C18.5 21.8284 17.8284 22.5 17 22.5H8C7.17157 22.5 6.5 21.8284 6.5 21V6.5Z"
      stroke="currentColor"
    />
    <rect
      x="0.5"
      y="-0.5"
      width="14"
      height="3"
      rx="1.5"
      transform="matrix(1 0 0 -1 5 6)"
      stroke="currentColor"
    />
    <path
      d="M10 3.5V3.5C10 2.11929 11.1193 1 12.5 1V1C13.8807 1 15 2.11929 15 3.5V3.5"
      stroke="currentColor"
    />
    <rect x="10" y="9" width="1" height="11" fill="currentColor" />
    <rect x="14" y="9" width="1" height="11" fill="currentColor" />
  </svg>
</template>
